import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { pmToolSensorIdSelector } from 'state/selectors/sensors-authorizations';
import useRaCostSetting from '../../settings/hooks/useRaCostSetting';
import { PM_PROVIDERS } from 'common/constants/constants';
import { resourceAllocationTypesEnum } from '@linearb/linjs-common';
import { getJiraEpicsRows } from './jiraEpics.rows';
import { getJiraInitiativesRows } from './jiraInitiatives.rows';
import { getJiraProjectsRows } from './jiraProjects.rows';
import { getAzureProjectsRows } from './azure.Projects.rows';
import { getAzureEpicsRows } from './azure.epics.rows';
import { getAzureFeaturesRows } from './azure.features.rows';
import { getJiraLabelsRows } from './jira.lables.rows';
import { getAzureTagsRows } from './azure.tags.rows';
import { getAzureCustomFieldRows } from './azure.custom-field.rows';
import { getJiraCustomFieldRows } from './jira.custom-field.rows';
import { ResourceAllocationFiltersContext } from '../../../state/filters/contexts';
import { getDynamicIssueTypesRows } from './dynamic_issue_types.rows';

const mapResouceTypeToGetRows = {
  [PM_PROVIDERS.JIRA]: {
    [resourceAllocationTypesEnum.PROJECT]: getJiraProjectsRows,
    [resourceAllocationTypesEnum.EPIC]: getJiraEpicsRows,
    [resourceAllocationTypesEnum.INITIATIVE]: getJiraInitiativesRows,
    [resourceAllocationTypesEnum.LABEL]: getJiraLabelsRows,
    [resourceAllocationTypesEnum.CUSTOM_FIELD]: getJiraCustomFieldRows,
    [resourceAllocationTypesEnum.DYNAMIC_ISSUE_TYPE]: getDynamicIssueTypesRows
  },
  [PM_PROVIDERS.AZURE_BOARDS]: {
    [resourceAllocationTypesEnum.PROJECT]: getAzureProjectsRows,
    [resourceAllocationTypesEnum.EPIC]: getAzureEpicsRows,
    [resourceAllocationTypesEnum.FEATURE]: getAzureFeaturesRows,
    [resourceAllocationTypesEnum.LABEL]: getAzureTagsRows,
    [resourceAllocationTypesEnum.CUSTOM_FIELD]: getAzureCustomFieldRows,
    [resourceAllocationTypesEnum.DYNAMIC_ISSUE_TYPE]: getDynamicIssueTypesRows
  }
};

const useTableRows = ({ data, resourceType }) => {
  const {
    state: { period, isInitialized }
  } = useContext(ResourceAllocationFiltersContext);
  const pmProvider = useSelector(pmToolSensorIdSelector);
  const raCost = useRaCostSetting();
  const [rows, setRows] = useState([]);

  const parseDataToRows = () => {
    const getRowsFn = mapResouceTypeToGetRows[pmProvider][resourceType.type];
    setRows(getRowsFn({ data, period, raCost }));
  };

  useEffect(() => {
    if (!isInitialized) return;
    parseDataToRows();
  }, [
    isInitialized,
    data,
    raCost.isEnabled,
    raCost.value,
    raCost.currency?.key
  ]);

  return rows;
};

export default useTableRows;
